<template>
  <Splash class="Home">
    <template slot="header">
      <h1>The Ultimate Replay Parser!</h1>
    </template>

    <template slot="caption">
      View game and player statistics from a growing database of Warcraft III custom game replays. Extract APM, ratings, custom map meta-data and more!
      <!--<br><br>
      <a href="https://www.patreon.com/wc3stats" target="_blank" class="yellow text-big">Sign up for our Patreon to help support this project!</a>-->
    </template>

    <template slot="content" class="container">
      <div class="row">
        <div class="col-md-6">
          <router-link to="upload">
            <img src="/assets/sneak-peek-1.png">
          </router-link>
        </div>

        <div class="col-md-6">
          <router-link :to="{
            name: 'Broken Alliances Leaderboard'
          }">
            <img src="/assets/sneak-peek-2.png">
          </router-link>
        </div>

        <div class="offset-md-4 col-md-4 mt60">
          <router-link
            :to="'upload'">
            <button class="Button--green">Get Started!</button>
          </router-link>
        </div>
      </div>
    </template>
  </Splash>
</template>

<script>
  import Splash from '@/legacy/components/layout/Splash';
  import { metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: 'Home'
      })
    },

    components: {
      Splash
    }
  };
</script>

<style lang="scss">
  .Home {
    // Other
    background:
      asset('background/home.jpg')               no-repeat,
      asset('background/home-repeat.jpg') center repeat-y;

    &-games {
      // Display & Box Model
      margin: 100px auto 0 auto;
      min-width: fetch(container ultrawide);
    }

    .Page-gutter {
      margin-bottom: 65px;
    }

    .Splash-content {
      img {
        // border: 1px solid rgba(var(--white), .3);
        // border-top: 0;
        // border-radius: 6px 6px 0 0;
      }
    }
  }
</style>